import { createAction } from '@ngrx/store';

import { httpError, payload } from 'ish-core/utils/ngrx-creators';

import { DotCmsContainerState } from './dotcms-container.reducer';

export const loadDotCmsContainer = createAction(
  '[DotCMS Container Internal] load dotCMS Container',
  payload<{ identifier: string }>()
);

export const loadDotCmsContainerSuccess = createAction(
  '[DotCMS Container API] load dotCMS Container Success',
  payload<{ container: DotCmsContainerState }>()
);

export const loadDotCmsContainerFail = createAction('[DotCMS Container API] load dotCMS Container Fail', httpError());

export const loadDotCmsContainersSuccess = createAction(
  '[DotCMS Container API] load dotCMS Containers Success',
  payload<{ containers: DotCmsContainerState }>()
);

export const loadDotCmsContainersFail = createAction('[DotCMS Container API] load dotCMS Containers Fail', httpError());
